var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import * as React from 'react';
import { Text, Stack, InlineChildren, StackChildren, Icon, } from '@doordash/design-language';
import { SearchField } from '@doordash/component-fields';
import Button from '@doordash/component-button';
import Tooltip from '@doordash/component-tooltip';
import { PORTAL_ROUTE_PREFIX, KEY_CODES, CONTACT_SALES_URL, } from '../constants/values';
import { FetchStatus, INITIAL_FETCH_STATUS } from '../constants/fetch_status';
import AddMembersModal from './Employees/add_members_modal';
import { AdminPageSubpageContentContainer, StyledDashPassIcon, } from './AdminPage/AdminPageStyles';
import AdminMembersList from './admin_members_list';
import RemoveMemberModal from './Employees/remove_member_modal';
import MembersLimitReachedModal from './Employees/MembersLimitReachedModal';
import track from '../utils/track';
import styled from 'styled-components';
import { MembersPageTestId } from './testId';
import { OnboardingStep } from '../types/GloblalTypes';
import { useSetOnboardingStepMutation } from './SelfServe/Onboarding/useSetOnboardingStepMutation';
import MembersStrings from './Employees/MembersStrings';
var ButtonContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  max-width: 150px;\n"], ["\n  max-width: 150px;\n"])));
var AdminMembersSubtitle = function (_a) {
    var shouldDisplaySearchSubtitle = _a.shouldDisplaySearchSubtitle, totalCount = _a.totalCount, searchValue = _a.searchValue, shouldDisplayLimitSubtitle = _a.shouldDisplayLimitSubtitle, showDashPassIndicator = _a.showDashPassIndicator, membersLimitInfo = _a.membersLimitInfo, isSearchMode = _a.isSearchMode, teamAccountId = _a.teamAccountId;
    return (React.createElement(React.Fragment, null,
        shouldDisplaySearchSubtitle && (React.createElement(Text, { color: Text.Colors.TextTertiary }, "Showing " + totalCount + " results for \"" + searchValue + "\"")),
        React.createElement(InlineChildren, { justifyContent: InlineChildren.Justification.FlexStart, alignItems: InlineChildren.Alignment.FlexStart, size: InlineChildren.Sizes.XxxSmall },
            shouldDisplayLimitSubtitle ? (React.createElement(React.Fragment, null,
                React.createElement(Text, { color: Text.Colors.TextTertiary }, MembersStrings.membersPageSubtitleText(totalCount, membersLimitInfo === null || membersLimitInfo === void 0 ? void 0 : membersLimitInfo.limit)),
                React.createElement(Tooltip, { interactionType: Tooltip.InteractionTypes.ToggleClick, content: React.createElement(React.Fragment, null,
                        "You've added ",
                        totalCount,
                        " out of",
                        ' ', membersLimitInfo === null || membersLimitInfo === void 0 ? void 0 :
                        membersLimitInfo.limit,
                        " employees allowed by your Team plan. To add more members,",
                        ' ',
                        React.createElement(Button, { isInline: true, size: Button.Sizes.Small, type: Button.Types.Link, tag: "a", href: CONTACT_SALES_URL(teamAccountId), target: "_blank", rel: "noreferrer" },
                            React.createElement(Text, { styles: Text.Styles.Body2, textDecoration: Text.TextDecorations.Underline, color: Text.Colors.BannerInformationalIcon }, "contact sales")),
                        ' ',
                        "to upgrade to the Enterprise plan."), position: Tooltip.Positions.TopCenter, size: Tooltip.Sizes.Large }, function () { return (React.createElement(Icon, { size: Icon.Sizes.Medium, type: Icon.Types.InfoCircleLine, color: Icon.Colors.TextTertiary })); }))) : (!isSearchMode && (React.createElement(Text, { color: Text.Colors.TextSecondary },
                "Total: ",
                totalCount))),
            showDashPassIndicator && (React.createElement(React.Fragment, null,
                "\u00A0 | ",
                React.createElement(StyledDashPassIcon, null),
                React.createElement(Text, { color: Text.Colors.TextSecondary }, "All members are eligible for DashPass"))))));
};
export var AdminMembers = function (_a) {
    var onToggleAdminAccess = _a.onToggleAdminAccess, _b = _a.members, members = _b === void 0 ? [] : _b, _c = _a.currentPage, currentPage = _c === void 0 ? 1 : _c, currentTeamMember = _a.currentTeamMember, history = _a.history, teamAccountId = _a.teamAccountId, totalCount = _a.totalCount, _d = _a.totalPages, totalPages = _d === void 0 ? 1 : _d, fetchMembersContent = _a.fetchMembersContent, teamAccountHasDashPass = _a.teamAccountHasDashPass, searchValue = _a.searchValue, fetchStatus = _a.fetchStatus, membersLimitInfo = _a.membersLimitInfo;
    var _e = __read(React.useState(searchValue || ''), 2), search = _e[0], setSearch = _e[1];
    var _f = __read(React.useState(null), 2), removeModalProps = _f[0], setRemoveModalProps = _f[1];
    var _g = __read(React.useState(false), 2), isAddMemberModalOpen = _g[0], setIsAddMemberModalOpen = _g[1];
    var hasReachedMembersLimit = (membersLimitInfo === null || membersLimitInfo === void 0 ? void 0 : membersLimitInfo.hasMaxMembersLimit) && totalCount >= membersLimitInfo.limit;
    React.useEffect(function () {
        setSearch('');
    }, [teamAccountId]);
    var fetchStatusPending = React.useCallback(function () {
        return (fetchStatus === INITIAL_FETCH_STATUS ||
            fetchStatus === FetchStatus.PENDING);
    }, [fetchStatus]);
    var openRemoveModal = React.useCallback(function (teamMember) {
        setRemoveModalProps({ teamAccountId: teamAccountId, teamMember: teamMember });
    }, [teamAccountId]);
    var closeRemoveModal = React.useCallback(function () {
        setRemoveModalProps(null);
    }, [setRemoveModalProps]);
    var onToggleAdminAccessCb = React.useCallback(function (member) {
        onToggleAdminAccess(member, teamAccountId).then(fetchMembersContent);
    }, [teamAccountId, fetchMembersContent, onToggleAdminAccess]);
    var onSearchInputChange = React.useCallback(function (value) {
        setSearch(value);
    }, [setSearch]);
    var onSearchKeyDown = React.useCallback(function (e) {
        if (e.keyCode === KEY_CODES.ENTER) {
            var query_1 = search ? "?email=" + search : '';
            history.push(PORTAL_ROUTE_PREFIX + "/admin/" + teamAccountId + "/members" + query_1);
        }
    }, [search, teamAccountId, history]);
    var query = searchValue ? "?email=" + searchValue : '';
    var onPageChange = React.useCallback(function (_a) {
        var requestedPage = _a.requestedPage;
        return history.push(PORTAL_ROUTE_PREFIX + "/admin/" + teamAccountId + "/members/" + requestedPage + query);
    }, [history, teamAccountId, query]);
    var isSearchMode = Boolean(searchValue);
    var showDashPassIndicator = teamAccountHasDashPass && !isSearchMode;
    var shouldDisplaySearchSubtitle = isSearchMode && totalCount > 0;
    var shouldDisplayLimitSubtitle = !isSearchMode && (membersLimitInfo === null || membersLimitInfo === void 0 ? void 0 : membersLimitInfo.hasMaxMembersLimit);
    var setOnboardingStep = useSetOnboardingStepMutation(teamAccountId, OnboardingStep.ONBOARDING_STEP_ADD_MEMBER).setOnboardingStep;
    var onAddMemberSuccess = function () {
        setOnboardingStep();
        fetchMembersContent();
    };
    return (React.createElement(AdminPageSubpageContentContainer, null,
        React.createElement(Stack, { size: Stack.Sizes.XLarge },
            React.createElement(InlineChildren, { justifyContent: InlineChildren.Justification.SpaceBetween, alignItems: InlineChildren.Alignment.Center },
                React.createElement(StackChildren, { size: Stack.Sizes.XxxSmall },
                    React.createElement(Text, { color: Text.Colors.TextPrimary, styles: Text.Styles.SectionTitleLarge, weight: Text.Weights.Medium }, "Employees"),
                    !fetchStatusPending() && (React.createElement(AdminMembersSubtitle, { shouldDisplaySearchSubtitle: shouldDisplaySearchSubtitle, totalCount: totalCount, searchValue: searchValue, shouldDisplayLimitSubtitle: shouldDisplayLimitSubtitle, showDashPassIndicator: showDashPassIndicator, membersLimitInfo: membersLimitInfo, isSearchMode: isSearchMode, teamAccountId: teamAccountId }))),
                React.createElement(InlineChildren, { justifyContent: InlineChildren.Justification.FlexEnd, alignItems: InlineChildren.Alignment.Center },
                    React.createElement(SearchField, { autoComplete: "off", value: search, onChange: onSearchInputChange, onKeyDown: onSearchKeyDown, label: "Search", isLabelHidden: true, placeholder: "Search employee", "data-testid": MembersPageTestId.SearchField }),
                    React.createElement(ButtonContainer, null,
                        React.createElement(Button, { type: Button.Types.PrimaryPill, onClick: function () {
                                setIsAddMemberModalOpen(true);
                                track('workportal_click_add_members');
                            }, "data-testid": MembersPageTestId.AddMembersButton }, "Add Members")),
                    isAddMemberModalOpen ? (hasReachedMembersLimit ? (React.createElement(MembersLimitReachedModal, { maxMembersLimit: membersLimitInfo.limit, onClose: function () { return setIsAddMemberModalOpen(false); }, teamAccountId: teamAccountId })) : (React.createElement(AddMembersModal, { teamAccountId: teamAccountId, onClose: function () { return setIsAddMemberModalOpen(false); }, onMemberAdded: onAddMemberSuccess, maxMembersLimit: membersLimitInfo === null || membersLimitInfo === void 0 ? void 0 : membersLimitInfo.limit, totalMembersCount: totalCount }))) : null))),
        removeModalProps && (React.createElement(RemoveMemberModal, __assign({}, removeModalProps, { onClose: closeRemoveModal, onMemberRemoved: fetchMembersContent }))),
        React.createElement(AdminMembersList, { currentTeamMember: currentTeamMember, members: members, page: currentPage, totalPages: totalPages, onPageChange: onPageChange, isLoading: fetchStatusPending(), teamAccountId: teamAccountId, onRemoveMemberClick: openRemoveModal, onToggleAdminAccess: onToggleAdminAccessCb, isSearchMode: isSearchMode })));
};
export default AdminMembers;
var templateObject_1;
